import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authEvents, userEvents } from '../../utils/analytics';
import { loadAllCredits } from '../../services/api';
import './Form.css';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithCredentials } = useAuth();
  
  // If user came from a protected route, send them back there after auth
  const from = location.state?.from?.pathname || "/account";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError(null);

    try {
      const user = await loginWithCredentials(email, password);
      if (!user) throw new Error("Login failed");
      authEvents.login('email');
      userEvents.formSubmit('login', true);
      
      // Check if user has credits and set flag for certificate modal
      try {
        const creditsResponse = await loadAllCredits();
        if (creditsResponse.status === 'success') {
          // Set sessionStorage flag to show certificate modal on destination page
          sessionStorage.setItem('showCertificate', 'true');
        }
      } catch (creditsError) {
        // If credit check fails, just continue normally
        console.error('Error checking credits:', creditsError);
      }
      
      // Navigate to destination
      navigate(from, { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      const msg = err.response?.data?.detail ||
                 err.response?.data?.message ||
                 err.message ||
                 "Invalid email or password. Please try again.";
      setError(msg);
      userEvents.formSubmit('login', false);
      userEvents.error('login', msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="auth-section component-card">
        <h2 className="subtitle">Sign In</h2>
        <p className="text">Welcome back to Read The Tape</p>
        <form onSubmit={handleSubmit} className="form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        
          <div className="form-group">
            <label htmlFor="login-email">Email</label>
            <input
              type="email"
              id="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <input
              type="password"
              id="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <button 
            type="submit" 
            className="login-button btn-primary"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </>
  );
}

export default LoginForm;
